import { Pipe, PipeTransform } from "@angular/core";

@Pipe({name: 'filterGuests'})
export class FilterGuestsPipe implements PipeTransform {

    transform(value: string[], guests: { [key: string]: boolean } = {}) {
        return value.filter(id => !guests[id])
    }
}